export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6341.e9a7581d.jpg";